module.exports = __webpack_public_path__ + "img/icon-exclamation.2d50f511.svg";